// HOOKS
import { useContext } from "react";

// COMPONENTS
import InfoBar from "../infoBar.component";
import CountInfoTag from "../infoTags/count.infoTag.infoBar.component";
import SelectedInfoTag from "../infoTags/selected/seletcted.infoTag.compnent";
import { ticketColumns } from "../../../assets/variables/columns/ticket.columns";
// CONTEXT
import { SelectedTicketsContext } from "../../../contexts/tickets/selectedTickets.context";

const TicketInfoBar = ({
  metaData = { totalCount: 0 },
  selectedTagProps = { handleClear: () => {}, label: "" },
}) => {
  const { selectedTickets, resetSelectedTickets, removeSelectedTicket } =
    useContext(SelectedTicketsContext);
  return (
    <InfoBar>
      <CountInfoTag>Count: {metaData?.totalCount || 0}</CountInfoTag>
      <SelectedInfoTag
        handleSelectAll={resetSelectedTickets}
        handleSelect={removeSelectedTicket}
        defaultColumns={ticketColumns}
        selectedData={selectedTickets}
        handleClear={selectedTagProps?.handleClear}
        label={selectedTagProps?.label || ""}
      />
    </InfoBar>
  );
};

export default TicketInfoBar;
